import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchShops } from "redux/actions/shop";
import {
  addGuestCategory,
  deleteGuestCategory,
  simpleFetchGuestCategory,
  updateGuestCategory,
} from "redux/actions/guestCategory";
import styled from "styled-components";
import CommonTable, { CommonTableProps } from "components/CommonTable";
import GuestCategoryRes from "types/res/guestCategory/GuestCategoryRes";
import { FormType } from "components/FormField";
import CreateGuestCategoryReq from "types/req/guestCategory/CreateGuestCategoryReq";
import UpdateGuestCategoryReq from "types/req/guestCategory/UpdateGuestCategoryReq";
import { useTranslation } from "react-i18next";

const GuestCategory: React.FC = () => {
  const { t } = useTranslation("guest");
  const headers: { key: keyof GuestCategoryRes; label: string }[] = [
    { key: "name", label: t("category.headers.name") },
    { key: "shops", label: t("category.headers.shops") },
    { key: "pointGrantFlag", label: t("category.headers.pointGrantFlag") },
    { key: "unUseUserFlag", label: t("category.headers.unUseUserFlag") },
    { key: "secondUserFlag", label: t("category.headers.secondUserFlag") },
  ];
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.account.staff.companyId);
  const company = useSelector((state) => state.account.staff.company);
  const guestCategory = useSelector((state) => state.guestCategory);
  const shops = useSelector((state) => state.shop);
  const [defaultShops, setDefaultShops] = useState<number[]>([]);

  useEffect(() => {
    dispatch(fetchShops(companyId));
    dispatch(simpleFetchGuestCategory(companyId));
  }, [companyId, dispatch]);

  useEffect(() => {
    setDefaultShops(
      company.guestCategoryShopFlag ? [] : shops.map((shop) => shop.shopId)
    );
  }, [shops]);
  const forms = [
    {
      label: t("category.forms.name"),
      key: "name",
      type: FormType.Text,
    },
    {
      label: t("category.forms.shops"),
      key: "shops",
      type: FormType.MultiOptions,
      options: shops.map((s) => ({ id: Number(s.shopId), name: s.name })),
      value: (val: any) => val.map((s: any) => s.shopId),
      disabled: !company.guestCategoryShopFlag,
    },
    {
      label: t("category.forms.pointGrantFlag"),
      key: "pointGrantFlag",
      type: FormType.Boolean,
      options: [
        { id: "0", name: t("category.notGrant") },
        { id: "1", name: t("category.grant") },
      ],
    },
    {
      label: t("category.forms.unUseUserFlag"),
      key: "unUseUserFlag",
      type: FormType.Boolean,
      options: [
        { id: "0", name: t("category.notGrant") },
        { id: "1", name: t("category.grant") },
      ],
    },
    {
      label: t("category.forms.secondUserFlag"),
      key: "secondUserFlag",
      type: FormType.Boolean,
      options: [
        { id: "0", name: t("category.notGrant") },
        { id: "1", name: t("category.grant") },
      ],
    },
  ];
  return (
    <>
      <GuestCategoryTable
        title={t("category.title")}
        formId="guestCategoryForm"
        forms={forms}
        rows={headers}
        data={guestCategory}
        addType={CreateGuestCategoryReq}
        updateType={UpdateGuestCategoryReq}
        addFunc={(formData) => addGuestCategory(companyId, formData)}
        updateFunc={(formData) => updateGuestCategory(companyId, formData)}
        deleteFunc={(item) =>
          deleteGuestCategory(companyId, {
            guestCategoryId: item.guestCategoryId,
          })
        }
        defaultValue={{ shops: defaultShops }}
        values={[
          (s) => s.name,
          (s) =>
            !company.guestCategoryShopFlag
              ? t("category.allShops")
              : s.shops?.map((shop) => shop.name).join(",") ||
                t("category.notSet"),
          (s) => (s.pointGrantFlag ? t("category.grant") : t("category.notGrant")),
          (s) => (s.unUseUserFlag ? t("category.grant") : t("category.notGrant")),
          (s) => (s.secondUserFlag ? t("category.grant") : t("category.notGrant")),
        ]}
      />
    </>
  );
};

const GuestCategoryTable = styled<
  React.FC<
    CommonTableProps<
      GuestCategoryRes,
      CreateGuestCategoryReq,
      UpdateGuestCategoryReq
    >
  >
>(CommonTable)`
  margin-top: 24px;
`;

export default GuestCategory;
